<template>
  <m-dialog ref="dlg" :btnsave="false" title="Tambah Mutasi Pegawai">
    <v-container>
      <v-row row wrap justify="center" align="center">
        <v-col cols="8">
          <v-form @submit.prevent data-vv-scope="form" lazy-validation>
            <v-row wrap>
              <v-col cols="12" sm="12" md="12" xl="12" lg="12">
                <v-stepper v-model="step">
                  <v-stepper-header>
                    <v-stepper-step :complete="step > 1" step="1">Lengkapi Data</v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step step="2">Konfirmasi</v-stepper-step>
                  </v-stepper-header>
                  <v-stepper-items>
                    <v-stepper-content step="1">
                      <v-row>
                        <v-col cols="12" md="12" sm="12">
                          <span class="font-weight-medium body-1"> Data Organisasi Asal</span>
                        </v-col>
                        <v-col cols="12" md="6" sm="12" class="py-0">
                          <label class="caption my-2">Organisasi Asal <span class="red--text">*</span></label>
                          <v-autocomplete
                            dense
                            single-line
                            outlined
                            label="Pilih Organisasi"
                            name="organisasi_id"
                            id="organisasi_id"
                            v-model="form.organisasi_id_asal"
                            hint="Pilih Organisasi"
                            data-vv-name="organisasi_id"
                            data-vv-as="Organisasi"
                            v-validate="'required'"
                            :items="organisasis"
                            item-value="organisasi_id"
                            item-text="nama"
                            :error-messages="errors.collect('form.organisasi_id')"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" sm="12" class="py-0">
                          <label class="caption my-2">Nama / NIP <span class="red--text">*</span></label>
                          <v-autocomplete
                            dense
                            single-line
                            outlined
                            label="Pilih Nama / NIP"
                            name="user_id"
                            id="user_id"
                            :hint="`${
                              !form.organisasi_id_asal
                                ? 'Silakan pilih organisasi asal terlebih dahulu, atau jika tetap kosong, artinya dalam organisasi tidak tersedia anggota'
                                : 'Pilih Anggota'
                            }`"
                            persistent-hint
                            v-model="form.user_id"
                            data-vv-name="user_id"
                            data-vv-as="Nama"
                            v-validate="'required'"
                            :items="listUsers"
                            item-value="user_id"
                            item-text="nama"
                            :error-messages="errors.collect('form.user_id')"
                          >
                          </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <span class="font-weight-medium body-1"> Data Organisasi Tujuan</span>
                        </v-col>
                        <v-col cols="12" md="6" sm="12" class="py-0">
                          <label class="caption my-2">Tenant Tujuan <span class="red--text">*</span></label>
                          <v-autocomplete
                            dense
                            single-line
                            outlined
                            label="Pilih Tenant"
                            name="tenant_id"
                            id="tenant_id"
                            v-model="form.kode_tenant"
                            hint="Pilih Tenant"
                            data-vv-name="tenant_id"
                            data-vv-as="Tenant"
                            v-validate="'required'"
                            :items="tenants.filter((s) => Number(s.is_connected) === 1)"
                            item-value="no_reg"
                            item-text="nama"
                            :error-messages="errors.collect('form.tenant_id')"
                            no-data-text="Anda belum menghubungkan tenant manapun"
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" sm="12" class="py-0">
                          <label class="caption my-2">Organisasi Tujuan <span class="red--text">*</span></label>
                          <v-autocomplete
                            dense
                            outlined
                            label="Pilih Organisasi"
                            name="organisasi_id"
                            id="organisasi_id"
                            :hint="`${
                              !form.kode_tenant
                                ? 'Pilihan Organisasi tujuan tidak ada, karena belum terhubung dengan tenant manapun'
                                : 'Pilih Organisasi'
                            }`"
                            persistent-hint
                            v-model="form.organisasi_id_tujuan"
                            data-vv-name="organisasi_id"
                            data-vv-as="Organisasi"
                            v-validate="'required'"
                            :items="orgsTujuan"
                            item-value="organisasi_id"
                            item-text="nama"
                            :error-messages="errors.collect('form.organisasi_id')"
                            no-data-text=""
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="6" sm="12">
                          <label class="caption my-2"
                            >Tanggal user aktif di organisasi tujuan <span class="red--text">*</span></label
                          >
                          <m-datepicker
                            dense
                            single-line
                            outlined
                            label="Tanggal user aktif"
                            v-model="form.tgl_mutasi"
                            hint="Tanggal user aktif di organisasi tujuan"
                            persistent-hint
                            data-vv-name="tgl_mutasi"
                            data-vv-as="Tanggal Mutasi"
                            v-validate="'required'"
                            :min="new Date().toISOString()"
                            :error-messages="errors.collect('form.mutasi')"
                          ></m-datepicker>
                        </v-col>
                        <v-col cols="12" md="6" sm="12">
                          <label class="caption my-2">Tanggal Mulai <span class="red--text">*</span></label>
                          <m-datepicker
                            dense
                            single-line
                            outlined
                            label="Tanggal Mulai*"
                            v-model="form.tgl_mulai"
                            :hint="
                              !form.tgl_mutasi
                                ? 'Harap pilih tanggal aktif user terlebih dahulu'
                                : 'Tanggal mulai riwayat presensi dipindah ke organisasi tujuan'
                            "
                            persistent-hint
                            data-vv-name="tgl_mulai"
                            data-vv-as="Tanggal Mulai"
                            v-validate="'required'"
                            :disabled="!form.tgl_mutasi"
                            :max="
                              form.tgl_mutasi
                                ? new Date(new Date().setDate(new Date(form.tgl_mutasi).getDate() - 1)).toISOString()
                                : ''
                            "
                            :error-messages="errors.collect('form.tgl_mulai')"
                          ></m-datepicker>
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <MFileInput
                            ref="fileinput"
                            v-model="form.file"
                            label="Dokumen Mutasi (SK Mutasi)"
                            :accept="['.pdf']"
                            @input="checkFile"
                          />
                        </v-col>
                        <v-col cols="12" md="12" sm="12">
                          <label class="caption my-2">Keterangan <span class="red--text">*</span></label>
                          <v-textarea
                            v-model="form.keterangan"
                            label="Tuliskan Keterangan Mutasi"
                            dense
                            single-line
                            outlined
                            rows="2"
                            data-vv-name="keterangan"
                            data-vv-as="Keterangan"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.keterangan')"
                          ></v-textarea>
                        </v-col>
                        <v-col cols="12" sm="12" md="12" class="text-right">
                          <v-btn name="simpan" depressed color="primary" @click="next">
                            Lanjut<v-icon right>mdi-arrow-right</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                      <v-row wrap justify-center>
                        <v-col cols="12" sm="12" md="12">
                          <p class="pa-2 black--text"
                            >Anda yakin ingin melakukan <b>mengajukan mutasi</b> pada anggota berikut ini ?
                          </p>
                          <v-card flat class="grey lighten-4">
                            <v-card-text>
                              <v-row>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Nama/NIP Anggota</div>
                                  <div class="black--text">
                                    <b>{{ (detil && detil.user && detil.user.nama) || '' }}</b>
                                    ({{ (detil && detil.user && detil.user.no_pegawai) || '' }})
                                  </div>
                                </v-col>

                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Dokumen Mutasi</div>
                                  <div class="black--text">
                                    {{ (form && form.file && form.file.name) || 'Belum ditambahkan' }}
                                    <v-btn v-if="url_file" small depressed class="mx-2" color="primary" @click="toLink">
                                      <v-icon left>mdi-eye</v-icon> Lihat Dokumen
                                    </v-btn>
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Organisasi Asal</div>
                                  <div class="black--text font-weight-bold">
                                    {{ getDeepObj(objOrgs, 'asal.nama') || '' }}
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Organisasi Tujuan</div>
                                  <div class="black--text font-weight-bold">
                                    {{ getDeepObj(objOrgs, 'tujuan.nama') || '' }}
                                  </div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Tanggal Mulai (riwayat presensi ditarik)</div>
                                  <div class="black--text"> {{ (detil && detil.tgl_mulai) || '' }} </div>
                                </v-col>
                                <v-col cols="12" md="6" sm="12">
                                  <div class="text-muted caption">Tanggal Mutasi (user aktif di organisasi tujuan)</div>
                                  <div class="black--text"> {{ (detil && detil.tgl_mutasi) || '' }} </div>
                                </v-col>
                                <v-col cols="12" md="12" sm="12">
                                  <div class="text-muted caption">Keterangan</div>
                                  <div class="black--text">
                                    {{ form.keterangan || '-' }}
                                  </div>
                                </v-col>
                              </v-row>
                            </v-card-text>
                          </v-card>

                          <v-col cols="12" md="12" sm="12">
                            <v-checkbox v-model="konfirmasi">
                              <template v-slot:label>
                                <div class="black--text body-2">
                                  Saya
                                  <b>Yakin akan mengajukan mutasi</b> pada anggota diatas, dan data mutasi yang saya
                                  inputkan telah sesuai
                                </div>
                              </template>
                            </v-checkbox>
                          </v-col>
                          <v-col cols="12" sm="12" md="12" class="d-flex justify-space-between mt-5">
                            <v-btn depressed text color="primary" @click="step = 1">Kembali</v-btn>&nbsp;
                            <v-btn name="simpan" :disabled="!konfirmasi" depressed color="primary" @click="save">
                              {{ Number(current_user && current_user.is_admin) === 1 ? 'Simpan' : 'Ajukan' }}
                              <v-icon right>mdi-content-save</v-icon>
                            </v-btn>
                          </v-col>
                        </v-col>
                      </v-row>
                    </v-stepper-content>
                  </v-stepper-items>
                </v-stepper>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
      </v-row>
    </v-container>
  </m-dialog>
</template>
<script>
import MFileInput from '@/components/MFileInput'
import { toSD } from '@/tools'
export default {
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    organisasis: {
      type: Array,
      default: () => [],
    },
    tenants: {
      type: Array,
      default: () => [],
    },
    progress: {
      type: Array,
      default: () => [],
    },
  },
  $_veeValidate: {
    validator: 'new',
  },
  components: { MFileInput },
  data() {
    return {
      step: 1,
      form: {},
      url_file: '',
      konfirmasi: null,
      orgsTujuan: [],
    }
  },
  computed: {
    detil() {
      const user = this.users.find((s) => Number(s.user_id) === Number(this.form.user_id))
      const organisasi = this.organisasis.find((s) => Number(s.organisasi_id) === Number(this.form.organisasi_id))

      return {
        user: user,
        tgl_mulai: toSD(this.form.tgl_mulai || ''),
        tgl_mutasi: toSD(this.form.tgl_mutasi || ''),
        organisasi_tujuan: organisasi,
      }
    },

    objOrgs() {
      const orgAsal =
        this.organisasis.find((s) => Number(s.organisasi_id) === Number(this.form.organisasi_id_asal)) || {}
      const orgTujuan =
        this.orgsTujuan.find((s) => Number(s.organisasi_id) === Number(this.form.organisasi_id_tujuan)) || {}
      return {
        asal: orgAsal,
        tujuan: orgTujuan,
      }
    },

    listUsers() {
      let users = this.users
      this.progress.forEach((key) => {
        const findIndex = users.findIndex((s) => Number(s.user_id) === Number(key)) || {}
        if (findIndex > -1) {
          users.splice(findIndex, 1)
        }
      })

      return users
    },
  },
  methods: {
    open() {
      this.$refs.dlg.open()
      this.reset()
    },

    reset() {
      this.$set(this, 'form', {
        tgl_mulai: null,
        tgl_mutasi: null,
        user_id: '',
        organisasi_id_asal: '',
        organisasi_id_tujuan: '',
        kode_tenant: '',
        keterangan: '',
      })
      this.$refs.fileinput.file = null
      this.step = 1
      this.url_file = ''
      this.konfirmasi = null
      this.$validator.reset()
    },

    next() {
      this.$validator.validateAll('form').then((res) => {
        if (!res) return Promise.reject()
        if (!this.form.file) {
          this.$error('Harap Melampirkan Dokumen Mutasi')
          return
        }
        this.step = 2
      })
    },

    checkFile(file) {
      let blob = new Blob([file], { type: `${file.type}` })
      this.url_file = URL.createObjectURL(blob)
    },

    save() {
      const formData = new FormData()

      Object.keys(this.form).forEach((key) => {
        formData.append(key, this.form[key])
      })

      this.$store
        .dispatch('mutasi/saveTenant', { no_reg: this.current_user.kode_tenant, params: formData })
        .then((resp) => {
          if (resp.status) {
            this.$success('Mutasi berhasil ditambahkan')
            this.$refs.dlg.dialog = false
            this.$emit('refresh')
          }
        })
    },

    toLink() {
      window.open(this.url_file, '_blank')
    },

    setOrgsTujuan(id) {
      if (!id) return
      this.orgsTujuan = []
      this.$store
        .dispatch('organisasi/get', {
          count: 100,
          kode_tenant: id,
        })
        .then(({ data }) => {
          this.orgsTujuan = data.data || []
        })
    },

    setUserAsal(id) {
      if (!id) return
      const org = this.organisasis.find((s) => Number(s.organisasi_id) === Number(id)) || {}
      this.$emit('getUser', org.kode_organisasi)
    },
  },
  watch: {
    'form.kode_tenant': 'setOrgsTujuan',
    'form.organisasi_id_asal': 'setUserAsal',
  },
}
</script>
